import { Ref } from 'vue';
import { ISectionContent } from './ISectionContent';

export class SectionContentCB {
	public content: Ref<ISectionContent>;

	public constructor(content: Ref<ISectionContent>) {
		this.content = content;
	}
}
